var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheraicon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7408 12.2308C11.6184 12.1908 10.8454 11.8423 11.3284 10.3738H11.3215C12.5808 9.07693 13.5431 6.99 13.5431 4.93539C13.5431 1.77616 11.4423 0.120003 9.00076 0.120003C6.55768 0.120003 4.46845 1.77539 4.46845 4.93539C4.46845 6.99846 5.42537 9.09385 6.69229 10.3877C7.18614 11.6831 6.30306 12.1638 6.11845 12.2315C3.56152 13.1562 0.561523 14.8415 0.561523 16.5054V17.1292C0.561523 19.3962 4.95691 19.9115 9.0246 19.9115C13.0984 19.9115 17.4384 19.3962 17.4384 17.1292V16.5054C17.4384 14.7915 14.4238 13.1192 11.7408 12.2308Z",
    fill: "#1D7E7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheraicon1);
export default __webpack_public_path__ + "static/media/theraicon1.519596457e72294ce44451090efc2059.svg";
export { ForwardRef as ReactComponent };